var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"id":_vm.id,"options":_vm.settings.options},on:{"change":_vm.onChange},model:{value:(_vm.settings.selectedPageSize),callback:function ($$v) {_vm.$set(_vm.settings, "selectedPageSize", $$v)},expression:"settings.selectedPageSize"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }